import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import ExchangeStepAnswerButton from "../../../../../../molecules/ActiveLearning/ExchangeStepAnswerButton";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import { ReactComponent as IconDelete } from "../../../../../../assets/images/ActiveLearning/icon_delete.svg";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage14 from "../../../../../../assets/images/ActiveLearning/hint/img_14.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  const question2 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 2);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          アイデアの実現をゴールとしたときに、ゴールに辿り着くためにはどのようなステップが必要かを考えよう。
        </p>
      </div>
      {question2 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question2.title}</p>
          <p className={styles.read}>
            ヒントを参考に、まずはやることを具体的に洗い出そう。
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
      <img src={hintImage14} alt="やることを考えるためのヒント" />
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question1.title}</p>
            <p className={styles.read}>
              やることの優先順位を決め、解決のアイデアを実現するためのステップを考えよう。
            </p>
          </div>
          <div className={styles.tree}>
            <TreeCard
              title={"解決のアイデア"}
              text={"回答データがありません。"}
            />
            <ul className={styles.branchList}>
              {[...Array(5)].map((_, index, array) => (
                <li className={styles.branch}>
                  <div className={styles.labelWrapper}>
                    <span className={styles.label}>
                      ステップ{array.length - index}
                    </span>
                  </div>
                  <div className={styles.inputField}>
                    <TextInput width={"100%"} />
                  </div>
                  <ExchangeStepAnswerButton
                    index={index}
                    length={array.length - 1}
                  />
                  <div className={styles.deleteButton}>
                    <Button
                      variant={"secondary"}
                      width={"80px"}
                      height={"37px"}
                      fontSize={"14px"}
                    >
                      <IconDelete />
                      削除
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
        </div>
      )}
      <Card label={"TRY"} icon={<IconLive />} title={"グループワーク"}>
        ①同じテーマ同士でグループをつくろう。
        <br />
        ②実現したいと思う解決のアイデアと実現のためのステップを発表し合おう。
        <br />
        ③ステップをより具体的にするための話し合いをし、ステップを調整しよう。
      </Card>
    </div>
  );
};
export default Issue1Material;
